import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import BrandMark from '../components/BrandMark';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Envoi impossible pour le moment.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <BrandMark />
        <h1 className="font-serif text-3xl text-ink mt-8 mb-2">Mot de passe oublié</h1>
        <p className="text-sm text-ink-muted mb-6">
          Indiquez l’email du compte. S’il existe, vous recevrez un lien valable une heure.
        </p>
        {sent ? (
          <div className="card p-6 text-sm text-ink-muted leading-relaxed">
            Si un compte correspond à cette adresse, un email vient d’être envoyé. Vérifiez aussi les
            indésirables.
            <Link to="/login" className="block mt-4 text-forest-700 hover:underline">
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="card p-6 space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-ink mb-1">
                Email
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
              />
            </div>
            {error && <p className="text-sm text-red-800">{error}</p>}
            <button type="submit" disabled={loading} className="btn btn-primary w-full">
              {loading ? 'Envoi…' : 'Envoyer le lien'}
            </button>
            <Link to="/login" className="block text-center text-sm text-ink-muted hover:text-ink">
              Annuler
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
